import { DashboardFilter } from '../../../filters/dashboard_filter';
import { MetricProfile } from '../../../dashboard-config/metrics/metric-profile';
import { createKpiFilters } from '../../../dashboard-config/kpis/kpi-filters';
import { DashboardIndexIndicatorSingleSelectFilter } from '../../../dashboard-config/kpis/index-indicators';

export type IndexPopupSlot =
  | 'revenue'
  | 'employed'
  | 'gva'
  | 'economic_participants';

/** Development bar+line WZ employed popup extension. */
export type IndexRankingDevelopmentPopupSlot = IndexPopupSlot | 'employedWz';

export const INDEX_VALUE_KEY = 'value';
export const INDEX_VALUE_COUNT_KEY = 'value_count';
export const INDEX_VALUE_SALES_KEY = 'value_sales';
export const INDEX_VALUE_EMPLOYED_KEY = 'value_employed';
export const INDEX_VALUE_EMPLOYED_STATE_KEY = 'value_employed_state';

/** GVA index options only available on sub-market / WZ (ranking-development) dashboards. */
export const INDEX_GVA_SUB_MARKET_WZ_ONLY_OPTIONS = [
  'gross_value_added_production_value_pct',
  'gross_value_added_per_employed_social_security__k_eur',
  'gross_value_added_per_economic_participants_core_market__k_eur',
];

/**
 * Filters of an index metric: hidden `metric_id`, the `kpi` filter where the type
 * matters (Employed visible, Economic participants hidden), and the indicator.
 */
export function createIndexFilters(
  base: MetricProfile,
  options: { type: 'visible' | 'hidden' | 'none'; excludedIndicators?: readonly string[] },
): DashboardFilter<any>[] {
  const [metricIdFilter, kpiFilter] = createKpiFilters(base, undefined, {
    showInFilterComponent: options.type === 'visible',
  });
  return [
    metricIdFilter,
    ...(options.type === 'none' ? [] : [kpiFilter]),
    new DashboardIndexIndicatorSingleSelectFilter({ metricId: base.id, excluded: options.excludedIndicators }),
  ];
}
